exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host.horizontal igo-list{width:auto;white-space:nowrap}:host.horizontal igo-toolbar-item{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/tool/toolbar/toolbar.component.styl
// module id = 958
// module chunks = 0